<template>
  <BarChart
    :chart-data="datacollection"
    :bar-options="{}"
    css-classes="application-chart-container"
  />
</template>

<script>
import BarChart from '@/components/chart/charts/Bar.js'

import { mapGetters } from 'vuex'

import cloneDeep from 'lodash/cloneDeep'

export default {
  components: { BarChart },
  data() {
    return {
      datacollection: {},
    }
  },
  computed: {
    ...mapGetters({
      report: 'application/currentReport',
    }),
  },
  watch: {
    report: {
      handler: function () {
        if (!this.report) return
        this.datacollection = cloneDeep(this.report)
      },
      deep: false,
      immediate: false,
    },
  },
}
</script>

<style lang="scss">
.application-chart-container {
  height: 300px;

  @include media_desktop() {
    height: 400px;
  }
}
</style>
